import React, { useContext } from "react";
import PropTypes from "prop-types";
import OPTIONS_CONTENT from "../../content/options.content";
import { PERIODS } from "../../content/index.content";
import { SimpleContext } from "../../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../../helpers";
import SimpleTitle from "./SimpleTitle";
import Payment from "./Payment";
import ComplexTitle from "./ComplexTitle";
import "./index.scss";

const Option = ({ optionName }) => {
  const {
    data: { optionsState, currentPeriod },
  } = useContext(SimpleContext);
  const status = optionsState[optionName];
  const { title, payment } =
    OPTIONS_CONTENT[currentPeriod || PERIODS[1]][optionName];

  return (
    <div
      className={getTrueClasses(
        "GP-C-O-O",
        status && "GP-C-O-O_active",
        `GP-C-O-O_${optionName}`
      )}
    >
      {title.type === "SimpleTitle" && (
        <SimpleTitle optionName={optionName} {...title} />
      )}
      {title.type === "ComplexTitle" && <ComplexTitle {...title} />}
      <Payment optionName={optionName} {...payment} />
    </div>
  );
};

Option.propTypes = {
  optionName: PropTypes.string.isRequired,
};

export default Option;
